import React from "react";
import { Container } from "react-bootstrap";
import "./businesspartner.css";
import logo from '../../asstes/images/logo102.jpg';
import logo10 from '../../asstes/images/Logo 2.png';
import logo16 from '../../asstes/images/logo100.jpg';
import logo17 from '../../asstes/images/logo101.jpg';
import logo18 from '../../asstes/images/logo103.jpg';
import logo4 from '../../asstes/images/logo104.jpg';
import logo5 from '../../asstes/images/logo105.jpg';
import logo6 from '../../asstes/images/logo106.jpg';
import logo7 from '../../asstes/images/logo107.jpg';
import logo8 from '../../asstes/images/logo108.jpg';
import logo9 from '../../asstes/images/logo109.jpg';
import logo11 from '../../asstes/images/logo110.jpg';
import logo12 from '../../asstes/images/sunway-logo.webp';
import logo13 from '../../asstes/images/Lincoln University College in Malaysia.webp';
import logo14 from '../../asstes/images/P&P.jpeg';
import logo15 from '../../asstes/images/Edustabl-Logo.png';
import logo19 from '../../asstes/images/temp1785147935959.jpeg';


const partnerLogos = [
    { logo: logo17, name: "NCERT" },
    { logo, name: "DSCHOOL - Kenya" },
    { logo: logo10, name: "BRITE WISSEN" },
    { logo: logo16, name: "SKILL GENIC" },
    { logo: logo18, name: "SS MPE SPORTS" },
    { logo: logo4, name: "RIVER BANK ACADEMY - Malaysia" },
    { logo: logo5, name: "NELKUALI - Mexico" },
    { logo: logo6, name: "ELPEE CONSULTS - Nigeria" },
    { logo: logo7, name: "UNIFUSION Consultants " },
    { logo: logo8, name: "MOLEBOHENG MATLI - South Africa" },
    { logo: logo9, name: "GKK Consultants - Malaysia" },
    { logo: logo11, name: "MANCHESTER Book House" },
    { logo: logo12, name: "SUNWAY UNIVERSITY - Malaysia" },
    { logo: logo13, name: "LINCOLN UNIVERSITY - Malaysia" },
    { logo: logo14, name: "Pure and Positive energy business solutions " },
    { logo: logo15, name: "Edustabl - Nigeria" },
    { logo: logo19, name: "Swami Vivekananda University" },
];

const BusinessPartner = () => {
    return (
        <>
            <section className="InnerPBanSec">
                <div className="IPBBgimg">
                    <img src={require('../../asstes/images/aboutBanBg.jpg')} alt="" />
                </div>
                <div className="BanContSec">
                    <Container>
                        <div
                            className="textBlack"
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}
                        >
                            <h1>Partner Institutions</h1>
                            <p style={{ marginTop: '20px', color: 'white', fontSize: '24px' }}>
                                UEDUCATE drives global educational innovation by partnering with leading
                                Institutions and Channels partners through its Collaborative Program for diverse academic disciplines
                            </p>
                        </div>
                    </Container>
                </div>
            </section>

            <section className="aboutIntrosec">
                <Container>
                    <div className="bpRefList">
                        <div className="bpLogoGrid">
                            {partnerLogos.map((partner, index) => (
                                <div className="bpCard text-center p-4" key={index}>
                                    <img src={partner.logo} alt={partner.name} className="bpBannerImg" />
                                    <h5 className="bpTitle">
                                        {partner.name.split(" - ").map((part, i) => (
                                            <React.Fragment key={i}>
                                                {i > 0 && <br />}
                                                {part}
                                            </React.Fragment>
                                        ))}
                                    </h5>
                                </div>
                            ))}
                        </div>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default BusinessPartner;